import { IDynamicLandingPageFields } from 'lib/contentful/landingPages';
import { ISearchModelFields } from 'lib/types/generated/contentful';
import { CateringCategoryValue } from 'qualification/schema/questions/cateringCategoriesQuestion';

export type DynamicLandingPageKeyword = NonNullable<
  IDynamicLandingPageFields['keywords']
>[number];

type SearchModelCateringCategory = NonNullable<
  ISearchModelFields['searchCateringCategory']
>[number];

type ContentfulCateringCategory =
  | DynamicLandingPageKeyword
  | SearchModelCateringCategory;

export const contentfulToCateringCategoryMapping: Record<
  ContentfulCateringCategory,
  CateringCategoryValue
> = {
  bbq: 'bbq',
  breakfast: 'breakfast',
  buffet: 'buffet',
  business_lunch: 'business_lunch',
  cakes_and_sweets: 'cakes_and_sweets',
  christmas: 'christmas',
  cocktailbar: 'drinks',
  dessert: 'cakes_and_sweets',
  dinner: 'fine_dining',
  drinks: 'drinks',
  fine_dining: 'fine_dining',
  fingerfood: 'fingerfood',
  foodtruck: 'street_food',
  street_food: 'street_food',
  summer_party: 'summer_party',
  event: 'other',
};

export const parseContentfulCateringCategory = (
  category: ContentfulCateringCategory
) => contentfulToCateringCategoryMapping[category];

export const parseContentfulCateringCategories = (
  categories: ContentfulCateringCategory[] | undefined | null
) => {
  if (!categories) {
    return undefined;
  }
  if (categories) {
    return categories.reduce((acc: CateringCategoryValue[], category) => {
      const mappedValue = parseContentfulCateringCategory(category);
      if (mappedValue) {
        acc.push(mappedValue);
      }
      return acc;
    }, []);
  }
};
